__turbopack_context__.v({
  "className": "instrument_serif_452f1617-module__xQ0Bha__className",
  "variable": "instrument_serif_452f1617-module__xQ0Bha__variable",
});
